import VideoListingContentComponent from "./VideoListingContentComponent";

const VideoListingNew =()=>{


    return (<>
        <VideoListingContentComponent
                tabKey={"new-videos"}
                showMostPopular={false}
                showMostLiked={false}
                showMyVideos={false}
                showAllVideos={false}
            /></>)
}
export default VideoListingNew;